export enum ReportStatusEnum {
  STARTED = "STARTED",
  QUEUED = "QUEUED",
  FAILED = "FAILED",
  FINISHED = "FINISHED",
  EMPTY = "EMPTY",
}
